import React, { ComponentType, ReactElement, createElement } from 'react';
import { classNames } from '../../utils';

export type ButtonSize = 'x-small' | 'small' | 'normal' | 'large' | 'x-large';
export type ButtonGroupItemColor =
  | 'default'
  | 'primary'
  | 'positive'
  | 'negative';

export interface ButtonGroupItem {
  title?: string;
  icon?: ReactElement | ComponentType<any>;
  disabled?: boolean;
  color?: ButtonGroupItemColor;
  onClick?: () => void;
}

interface Props {
  items: ButtonGroupItem[];
  size?: ButtonSize;
}

export default function ButtonGroup({ items }: Props) {
  return (
    <span className="isolate inline-flex rounded-md shadow-sm">
      {items.map((item, i) => (
        <button
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          type="button"
          className={classNames(
            'relative inline-flex items-center bg-white px-3 py-2 text-sm font-semibold ring-1 ring-inset focus:z-10 flex-1 ',
            i === 0 ? 'rounded-l-md' : undefined,
            i + 1 === items.length ? 'rounded-r-md' : undefined,
            {
              default:
                ' text-gray-700 hover:bg-gray-100 ring-gray-300 disabled:bg-gray-100 disabled:text-gray-400 disabled:ring-gray-200',
              primary:
                'text-indigo-600 hover:bg-indigo-50 ring-indigo-500 disabled:bg-indigo-50 disabled:text-indigo-300 disabled:ring-indigo-100',
              positive:
                'text-emerald-600 hover:bg-emerald-50 ring-emerald-600 disabled:bg-emerald-50 disabled:text-emerald-300 disabled:ring-emerald-100',
              negative:
                'text-red-500 hover:bg-red-50 ring-red-500 disabled:bg-red-50 disabled:text-red-300 disabled:ring-red-100',
            }[item.color || 'default'],
          )}
          disabled={item.disabled}
          onClick={item.onClick}
        >
          {item.icon ? (
            <span className={classNames('h-5 w-5', item.title ? 'me-3' : '')}>
              {React.isValidElement(item.icon)
                ? item.icon
                : createElement(item.icon as any, {
                    'aria-hidden': 'true',
                  })}
            </span>
          ) : undefined}
          {item.title}
        </button>
      ))}
    </span>
  );
}
